// extracted by mini-css-extract-plugin
export default {"container":"SearchPc_container__ZE8Kp","reset":"SearchPc_reset__oLFqV","label":"SearchPc_label__i5piy"};